import React, { Component } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { injectIntl, FormattedMessage } from 'react-intl';

import HUBContext from '../services/HUBContext';

const styles = theme => ({
    alert: {
        color: '#856404',
        backgroundColor: '#fff3cd',
        padding: '.75rem 1.25rem',
        marginBottom: '1rem',
        border: '1px solid #ffeeba',
        borderRadius: '.25rem'
    }
});

export class NoAuthorization extends Component {

    render() {
        const { classes } = this.props;

        return (<Grid container className={ classes.alert }>
                    <Grid item xs={12} sm={12} lg={12} xl={12}>
                        <FormattedMessage id='noAuthorization' defaultMessage='You are not authorized to perform this operation' />
                    </Grid>
                </Grid>);
    }

}

NoAuthorization.contextType = HUBContext;

export default withStyles(styles)(injectIntl(NoAuthorization));

